import { jsx as r } from "react/jsx-runtime";
import { Stack as u } from "@chakra-ui/react";
import { Step as v } from "./step.js";
import { StepContext as C } from "./step-context.js";
import { ThemeColorVariable as e, ThemeSpaceVariable as S } from "../../theme/theme-types.js";
function B({ activeStep: t, orientation: i = "vertical", steps: c = [], ...a }) {
  const m = i === "vertical", d = c.map((o, n) => {
    const l = n + 1, p = {
      orientation: i,
      isActiveStep: t === l,
      showDivider: n !== c.length - 1,
      label: o.label,
      icon: o.icon,
      color: o.color ?? e.OnBackgroundBorder,
      iconColor: o.iconColor ?? e.OnBackground,
      dividerColor: (o.dividerColor || o.color) ?? e.OnBackgroundBorder
    };
    return /* @__PURE__ */ r(C.Provider, { value: p, children: /* @__PURE__ */ r(v, {}) }, l);
  });
  return /* @__PURE__ */ r(u, { spacing: S.Small, direction: m ? "column" : "row", ...a, children: d });
}
export {
  B as Stepper
};
